<template>

        <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Service Information
            </h4>
          </md-card-header> -->
          <md-card-content>

            <div class="md-layout">
                <div class="md-layout-item">
              <autoextra :collection="bank" v-slot="{item,last,index}">
              <div :class="{last: last}">
                
               <div v-if="item.driver_bank_account_bank_name || last" class="columns">
                <label :id="'labelBankFlag__'+index" style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}Bank {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Bank Name</label>
                      <md-input  v-model="item.driver_bank_account_bank_name"   @change="onChangeBankName" />
                  
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Account No</label>
                      <md-input  v-model="item.driver_bank_account_no" :disabled="!item.driver_bank_account_bank_name" @change="onChangeBankNo(index, item.driver_bank_account_no)"/>
                    </md-field>
                    <span :id="'flagBank_'+index" style="display:none; color:red;">Field is required</span>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Bank Account Holder</label>
                      <md-input  v-model="item.driver_bank_account_holder" :disabled="!item.driver_bank_account_bank_name"/>
                  
                    </md-field>
                  </div>

                 
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense" @click="deleteColumn(index)" v-if="item.driver_bank_account_bank_name">
                    delete
                  </md-button>
                </md-card-actions>
                </div>            
              </div>
              </div> 
            </autoextra>
            </div>
            </div>
          </md-card-content>
        </md-card>  
</template>
<script>
// import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
  // import {extend} from 'vee-validate';
  // import { required } from 'vee-validate/dist/rules';
import  Autoextra  from 'vue-autoextra';

// extend('name', {
//   ...required,
//   message: 'Driver Name Field is required'
//   });
//   extend('gender', {
//   ...required,
//   message: 'Gender Field is required'
//   });
//   extend('Phone', {
//   ...required,
//   message: 'Phone Field is required'
//   });
export default {
  name: "bank-card",
props: ['driver'],

  components: {  Autoextra },

  mixins: [formMixin],
 
  data() {
    return {
     bank:[],
    };
  },
  
  created() {
          this.onOpen()
  },
  
  methods:{
    //fungsi saat pertamakali page di buka
    async onOpen(){
     
    },

      //ambil data dari parent, digunakan saat edit
      async getDataParent() { 
        // console.log(this.driver.driver_bank);
        // this.bank = this.driver.driver_bank
        //loop nilai bank untuk membuat autoextra row
        this.driver.driver_bank_account.forEach((value, index) => {
          this.$set(this.bank, index, {
                  id : value.id,
                  driver_bank_account_bank_name : value.driver_bank_account_bank_name,
                  driver_bank_account_no : value.driver_bank_account_no,
                  driver_bank_account_holder : value.driver_bank_account_holder,
                });
          });
        console.log(this.bank);
      },


  onChangeBankNo(index,data){
        let error = document.getElementById("flagBank_"+index);
        console.log(error)
        if(data!=null && data!=""){
        error.style.display = "none"
        }
        else{
          error.style.display = "block"
        }

      },

    
   onChangeBankName(){
      var filter = this.bank.filter(function(el) {
           console.log(el);
            return el != null;
          });
          // console.log(filter)
          var int= 0
          for (const [key, value] of Object.entries(filter)) {
                        //console.log(key);
                        //console.log(value);
                        if(!value.driver_bank_account_bank_name){
                          int++
                        }
                        else{
                          console.log(key-int);
                          this.$set(this.bank, key-int, {
                            id : value.id,
                            driver_bank_account_bank_name :value.driver_bank_account_bank_name,
                            driver_bank_account_no : value.driver_bank_account_no,
                            driver_bank_account_holder : value.driver_bank_account_holder,
                            
                          });
                          if(int!=0){
                            console.log("aaaaa")
                            this.$set(this.bank, key, {
                              id : null,
                             driver_bank_account_bank_name : null,
                            driver_bank_account_no : null,
                            driver_bank_account_holder : null,
                              
                              
                            });
                          }
                          
                          int= 0
                        }
                        

                      }
      // console.log(this.bank)
    },

    //fungsi untuk menghapus colum bank
    deleteColumn(index){
        if (index > -1) {
           this.bank.splice(index, 1)
        }
        //console.log(this.bank);
        
      },
      getData() {
        var filter = this.bank.filter(function(el) {
           console.log(el);
            return el != null;
          });
            this.$emit('data', filter)
        },
      async validateForm() {
            
            let result = []
            if(Object.keys(this.bank).length != 0){
                    for (const [key, value] of Object.entries(this.bank)) {
                        if(value.driver_bank_account_bank_name && (!value.driver_bank_account_no || value.driver_bank_account_no=="")){
                          
                          document.getElementById("flagBank_"+key).style.display = "block"
                          document.getElementById("labelBankFlag__"+key).scrollIntoView({behavior: 'auto'});
                          result.push(false)
                        }
                        }

                
                } 
              return result.every(Boolean)
          }
  },
};
</script>

<style scoped>


.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}</style>
